// GAVION booking: route elements of the public pages (CRM.tsx, noLayout, no login). The API is chosen here so the pages
// stay testable with a plain object.
import { ManageBookingPage } from "./ManageBookingPage";
import { PublicBookingPage } from "./PublicBookingPage";
import { usePublicBookingApi } from "./api/usePublicBookingApi";

export const PublicBookingRoute = () => <PublicBookingPage api={usePublicBookingApi()} />;
export const ManageBookingRoute = () => <ManageBookingPage api={usePublicBookingApi()} />;
